import { useHomepageScrollYRestoration } from "~/pages/home/hooks";

export const HomepageScrollPositionRestoration = () => {
  useHomepageScrollYRestoration({ triggerTiming: "afterLazyLoading" });

  return <div />;
};

HomepageScrollPositionRestoration.displayName = "HomepageScrollPositionRestoration";
